import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Left } from '../../../../components/Icon';
import { HBox } from '../../../../components/Box';
import { AddExtraCosts } from './AddExtraCosts';
import { COLOR_BG_LIGHT } from '../../../../vars';

const STATE = {
  addedProps: {},
  isAddSecondContact: false,
  download: true,
  sendToEmail: false,
  relation: null,
  contact: null,
  secondaryRelation: null,
  secondaryContact: null,
  extraEmail: null,

  isRequired: false,
  addDocument: false,
  addValue: '',
  deleteDocumentConfirm: null,
  documentDto: null,
};

const Container = styled.div`
  font-size: 14px;
  .title {
    font-size: 14px;
  }

  .section {
    margin-bottom: 24px;
  }

  strong {
    margin-bottom: 24px;
  }

  .search-top {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 90px;
    padding: 15px;
    font-weight: 600;

    background-color: ${COLOR_BG_LIGHT};

    .list-result-label {
      font-weight: 500;
      width: 50px;
      margin: 5px;
      text-align: center;
      background-color: black;
      color: #fff;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class ExtraCostsModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  reset() {
    this.props.sendAction('close');
  }

  render() {
    return (
      <Container>
        <HBox>
          {window.innerWidth <= 768 && (
            <HBox vCenter left className="search-top">
              <Left />
              {this.lbl('vehicle.overview.bulk_actions')}
              <p className="list-result-label">{this.props.vehicleIds?.length}</p>
            </HBox>
          )}

          <AddExtraCosts onClose={this.reset.bind(this)} vehicleIds={this.props.vehicleIds} />
        </HBox>
      </Container>
    );
  }
}

ExtraCostsModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ExtraCostsModal = compose(withConnect, withRouter, injectIntl)(ExtraCostsModalComp);
